module.exports = __webpack_public_path__ + "01_very_short_black.07ef8c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_very_short_black.png
// module id = yjEg
// module chunks = 0